import React from "react";
import manifest from "../data/webp.json";

/* Larghezze WebP disponibili (generate da scripts/gen_webp.py) e dimensioni
   originali, per srcset/sizes e attributi width/height contro i salti di layout. */

export function srcsetFor(src) {
  const e = manifest[src];
  if (!e || !e.w || !e.w.length) return null;
  const base = src.replace(/\.(jpg|jpeg|png)$/i, "");
  return e.w.map((w) => `${base}.${w}.webp ${w}w`).join(", ");
}

export function dimsFor(src) {
  const e = manifest[src];
  return e && e.o ? { width: e.o[0], height: e.o[1] } : null;
}

/* Props pronte da distribuire su <img>: WebP via srcset + fallback sull'originale
   (JPG/PNG), dimensioni intrinseche, priorità di caricamento o lazy. */
export function imgProps(src, { sizes = "100vw", priority = false, lazy = true } = {}) {
  const props = { src, decoding: "async" };
  const ss = srcsetFor(src);
  if (ss) {
    props.srcSet = ss;
    props.sizes = sizes;
  }
  if (priority) props.fetchPriority = "high";
  else props.loading = lazy ? "lazy" : "eager";
  const d = dimsFor(src);
  if (d) {
    props.width = d.width;
    props.height = d.height;
  }
  return props;
}

export function SmartImg({ src, alt = "", sizes = "100vw", priority = false, lazy = true, className = "", style, testid, onLoad }) {
  return (
    <img
      {...imgProps(src, { sizes, priority, lazy })}
      alt={alt}
      className={className}
      style={style}
      data-testid={testid}
      onLoad={onLoad}
    />
  );
}
